export const NEWSLETTER_FOOTER = 'Texelfanblok';
export const NEWSLETTER_HEADER = 'MijnTexel_header';
export const NEWSLETTER_FAVORITE = 'MijnTexel_liken';
